import { rem } from 'polished';
import styled from 'styled-components';

const CustomSwatchesContainer = styled.div`
    margin-bottom: ${rem(16)};
    margin-top: ${rem(8)};
`;

export default CustomSwatchesContainer;
